<template>
  <div id="app" :data-l="layout">
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
  const defaultLayout = "default-layout";

  export default {
    name: 'App',
    components: {

    },
    computed: {
      layout() {
        return (this.$route.meta.layout || defaultLayout);
      }
    }
  }
</script>

<style>

</style>